import { cn } from '@dashboard/ui'

interface DividerProps {
  className?: string
}

export const Divider = ({ className }: DividerProps) => {
  return <div className={cn('my-5 w-full border-b border-border-secondary', className)} />
}
